import { compose, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';

import {
  canEditNotJoinedPatient,
  canEditPatient,
  loggedUserCountrySelector,
  loggedUserIdSelector,
  targetUserSelector,
  isLoggedUserSelector,
  selectIsVerifiedDependentRole,
  selectShowOwnProviderProfile,
} from '../../../redux/context/selectors';
import {
  selectEditedUserErrors,
  selectEditedUserSending,
} from '../../../redux/profiles/selectors';
import { selectHealthInterestsList } from '../../../redux/data/selectors';
import { actions as editUserActions } from '../../../redux/profiles/edit-user';
import { actions as editPatientByProviderActions } from '../../../redux/profiles/edit-patient-by-provider';
import { actions as editAvatarActions } from '../../../redux/profiles/edit-avatar';
import { actions as changeSettingsActions } from '../../../redux/profiles/change-settings';
import { actions as reqSocialChannel } from '../../../redux/board/reqSocialChannel';
import styles from '../index.styl';

const mapStateToProps = state => ({
  profile: targetUserSelector(state),
  isProfileFetching: state.profiles.getUser.sending,
  editUserSending: selectEditedUserSending(state),
  editUserErrors: selectEditedUserErrors(state),
  healthInterestsList: selectHealthInterestsList(state),
  canEdit: canEditPatient(state),
  canEditOwnPatient: canEditNotJoinedPatient(state),
  loggedUserId: loggedUserIdSelector(state),
  loggedUserCountry: loggedUserCountrySelector(state),
  isLoggedUser: isLoggedUserSelector(state),
  isDependent: selectIsVerifiedDependentRole(state),
  showOwnProviderProfile: selectShowOwnProviderProfile(state),
});

const mapDispatchToProps = {
  saveUser: editUserActions.send,
  savePatientByProvider: editPatientByProviderActions.send,
  saveAvatar: editAvatarActions.send,
  saveSettings: changeSettingsActions.send,
  saveUserRequestClear: editUserActions.clear,
  createSocialChat: reqSocialChannel.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ editUserErrors }) => {
    return { errors: get(editUserErrors, 'meta.validationErrors') };
  }),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/Profile/enhance.js